import {
  Directive, Input, OnChanges, SimpleChanges
} from '@angular/core';
import {
  Validator, AbstractControl, NG_VALIDATORS, ValidatorFn, ValidationErrors
} from '@angular/forms';

export function invalidValueValidator(value: string): ValidatorFn {
  const invalid = typeof value === 'string' ? [value] : value;

  // if the invalid value isn't useful, don't bother checking
  if (!(invalid && invalid.includes)) {
    return () => null;
  }

  // otherwise, return a validator that looks for value in the list to exclude
  return (control: AbstractControl) => {
    if (invalid.includes(control.value)) {
      return { sonderInvalidOption: true };
    }

    return null;
  };
}

@Directive({
  selector: '[sonderInvalidValue]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: InvalidValueValidatorDirective, multi: true }
  ],
  standalone: false
})
export class InvalidValueValidatorDirective implements Validator, OnChanges {
  @Input() sonderInvalidValue: string | string[];

  private validator: ValidatorFn;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sonderInvalidValue']) {
      this.validator = invalidValueValidator(changes['sonderInvalidValue'].currentValue);
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validator && this.validator(control);
  }
}
